import React from 'react';
import { CellContext } from '@tanstack/react-table';

import { AdaptiveTableCell } from '@components/common';

import { IMoTreeFilters, TComparisonDetails } from '@interfaces/cmModule/cmModule';
import { TSelectOption } from '@interfaces/components/componentTypes';
import { TExtendedColumnDef, TTableFilter } from '@interfaces/components/table';

export const getDynamicColumns = (managedObjects?: string[]): TExtendedColumnDef[] => {
	return (
		managedObjects?.length
			? managedObjects.map((moName) => ({
				header: `${moName} ID`,
				accessorKey: `managedObjects_${moName}`,
				cell: ({ row }: CellContext<TComparisonDetails, any>) => {
					const managedObjects = row.original.managedObjects || [];
					const foundObject = managedObjects.find(data => data.moName === moName);

					return <AdaptiveTableCell text={foundObject?.moId} />;
				},
			}))
			: []
	);
};

export const generateFilters = (
	options: IMoTreeFilters[],
	selectedFilters: Record<string, any>,
	setSelectedGeneratedFilters: React.Dispatch<React.SetStateAction<Record<string, any>>>,
): TTableFilter[] => {
	return options.map((filter) => ({
		type: 'select',
		name: filter.moName,
		placeholder: `${filter.moName} ID`,
		option: selectedFilters[filter.moName] || null,
		options: filter.data,
		minWidth: '200px',
		setState: (option: TSelectOption<string>) => {
			setSelectedGeneratedFilters((prev) => {
				if (option?.name) {
					return {
						...prev,
						[option.name]: option,
					};
				}

				return {
					...prev,
					[filter.moName]: null,
				};
			});
		},
		defaultValue: null,
	}));
};
